import { render, staticRenderFns } from "./soviewspotcheckflag.vue?vue&type=template&id=1b251daa&scoped=true&"
import script from "./soviewspotcheckflag.vue?vue&type=script&lang=js&"
export * from "./soviewspotcheckflag.vue?vue&type=script&lang=js&"
import style0 from "./soviewspotcheckflag.vue?vue&type=style&index=0&id=1b251daa&lang=scss&scoped=true&"
import style1 from "./soviewspotcheckflag.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b251daa",
  null
  
)

export default component.exports